import { render, staticRenderFns } from "./Annotations.vue?vue&type=template&id=23721af0"
import script from "./Annotations.vue?vue&type=script&lang=js"
export * from "./Annotations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports